// Browser-side OpenAI call. The key is compiled into the public bundle, so it
// must be a restricted key with a spending cap — anyone visiting the site can
// read it.
const OPENAI_API_KEY =
  process.env.REACT_APP_OPENAI_API_KEY ||
  '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';
const OPENAI_MODEL = process.env.REACT_APP_OPENAI_MODEL || 'gpt-4o-mini';
const OPENAI_URL = 'https://api.openai.com/v1/chat/completions';

const SYSTEM_PROMPT = [
  'Je DPSHTRR Asist, asistentja virtuale e Drejtorisë së Përgjithshme të Shërbimeve të Transportit Rrugor në Shqipëri.',
  'Përgjigju VETËM shqip, qartë dhe miqësor, si një specialist në sportel.',
  'Fusha jote: leje drejtimi, targa, kontroll teknik, regjistrim mjetesh, certifikata profesionale (CAP, CKP, ADR, CEMT), taksa dhe shërbimet e tjera të DPSHTRR.',
  'Rregulla:',
  '- Mos shpik tarifa, afate, dokumente ose numra telefoni. Nëse nuk je i sigurt, thuaj se qytetari duhet të verifikojë në www.dpshtrr.al.',
  '- Shkruaj vetëm për Shqipërinë dhe DPSHTRR/DRSHTRR.',
  '- Për hapa ose dokumente përdor deri në 5 pika me •.',
  '- Për pyetje të thjeshta mjaftojnë 2–4 fjali.',
  '- Nëse pyetja nuk lidhet me shërbimet e transportit rrugor, kthe bisedën me mirësjellje te shërbimet e DPSHTRR.'
].join('\n');

export function isOpenAiConfigured() {
  return Boolean(OPENAI_API_KEY);
}

function parseOpenAiEvents(buffer) {
  const events = [];
  const parts = buffer.split('\n\n');
  const rest = parts.pop() ?? '';
  for (const part of parts) {
    const line = part
      .split('\n')
      .find((l) => l.startsWith('data: '));
    if (!line) continue;
    const payload = line.slice(6).trim();
    if (payload === '[DONE]') {
      events.push({ done: true });
      continue;
    }
    try {
      events.push({ data: JSON.parse(payload) });
    } catch (_) {
      /* ignore malformed chunk */
    }
  }
  return { events, rest };
}

function buildMessages(message, conversationHistory) {
  const prior = Array.isArray(conversationHistory)
    ? conversationHistory
        .filter((entry) => typeof entry === 'string' && entry.trim())
        .slice(-5)
        .map((entry) => ({ role: 'user', content: entry.trim() }))
    : [];

  return [
    { role: 'system', content: SYSTEM_PROMPT },
    ...prior,
    { role: 'user', content: message }
  ];
}

/**
 * Stream an answer straight from OpenAI into the chat bubble.
 * @returns {Promise<{ role: 'assistant', content: string, timestamp: Date, source: string }>}
 */
export async function streamOpenAiAnswer({ message, conversationHistory, onChunk }) {
  const resp = await fetch(OPENAI_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${OPENAI_API_KEY}`
    },
    body: JSON.stringify({
      model: OPENAI_MODEL,
      messages: buildMessages(message, conversationHistory),
      stream: true,
      temperature: 0.2,
      max_tokens: 600
    })
  });

  if (!resp.ok || !resp.body) {
    throw new Error(`openai failed: ${resp.status}`);
  }

  const reader = resp.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let content = '';

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const { events, rest } = parseOpenAiEvents(buffer);
      buffer = rest;

      for (const evt of events) {
        if (evt.done) continue;
        const piece = evt.data?.choices?.[0]?.delta?.content;
        if (!piece) continue;
        content += piece;
        onChunk?.(piece, content);
      }
    }
  } catch (err) {
    if (content && err && !err.streamedText) err.streamedText = content;
    throw err;
  }

  if (!content.trim()) {
    throw new Error('empty openai response');
  }

  return {
    role: 'assistant',
    content: content.trim(),
    timestamp: new Date(),
    source: 'openai'
  };
}
